import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { isNullOrUndefined } from "util";
import './techStackCard.css';

class TechStackCardComponent extends React.Component {
    
    constructor(props){

        super(props);
        //techStackList
    }

    render(){
        let scope = this;

        if(isNullOrUndefined(this.props.techStack))
            return null;
        let techStack = this.props.techStack;

        return (
            <Card className="newsCardContainer" variant="outlined" onClick={() => {window.open(scope.props.link)}}>
                <CardContent>
                    {!isNullOrUndefined(techStack['Tag'])?
                        <Typography color="textSecondary" className="newsCardSource" gutterBottom>
                            {techStack['Tag']}
                        </Typography>
                        :
                        null
                    }
                    {!isNullOrUndefined(techStack['Name'])?
                        <Typography variant="h7" component="h4" gutterBottom>
                            {techStack['Name']}
                        </Typography>
                        :
                        null
                    }
                    {!isNullOrUndefined(techStack['Description'])?
                        <Typography variant="body2" component="p" className="newsCardSnippet">
                            {techStack['Description']}
                        </Typography>
                        :
                        null
                    }
                </CardContent>
            </Card>
                
        )
    }
}
export default TechStackCardComponent;